/*local*/
 // export const API_HOST  = 'http://localhost:23119';
// export const API_HOST  = 'https://devhybrid.pochta.uz';
export const API_HOST  = 'https://hybrid.pochta.uz';
// export const IMPORT_REGISTRY_ACCESSED_INNS  = '489043363;583345961;201052713;203366731;207163412;207299464;307128450;345676534;';